export const vacationStatusOptions = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'On',
    value: 'on',
  },
  {
    label: 'Off',
    value: 'off',
  },
];
